import React, { useEffect, useState } from 'react';
import styles from './managers-card.module.scss';
import { useNavigate } from 'react-router-dom';
import { AppLinks } from 'app/router/consts/app-links.enum';
import { DefaultButton, ManagerMiniCard, SearchInput } from 'shared/ui';
import { businessStore, UserRoleEnum, userStore } from 'entities/index';
import { observer } from 'mobx-react';

interface IManagersCardProps {
  businessId?: string;
  pointId?: string;
}
export const ManagersCard: React.FC<IManagersCardProps> = observer(
  ({ businessId = '', pointId = '' }) => {
    const [inputValue, setInputValue] = useState('');
    const normalizedSearch = inputValue.toLowerCase().trim();

    const matchesSearch = (manager: { fio?: string }): boolean => {
      if (!normalizedSearch) return true;
      return manager.fio?.toLowerCase().includes(normalizedSearch) ?? false;
    };

    const navigate = useNavigate();

    const fetchManagers = async () => {
      if (businessId) {
        businessStore.initManagersBusinessWidgetData(businessId);
      } else if (pointId) {
        businessStore.initManagersPointWidgetData(pointId);
      }
    };

    useEffect(() => {
      fetchManagers();
    }, []);

    const navigateToCreateManager = () => {
      if (businessId || pointId) {
        const path = AppLinks.CreateManagerLink.replace(
          ':id',
          businessId + pointId
        );
        navigate(path);
      } else {
        navigate(AppLinks.AboutLink);
      }
    };

    return (
      <div className={styles.business_managers__container}>
        <div className={styles.container__search}>
          <SearchInput
            value={inputValue}
            placeholder="Поиск по менеджерам"
            onChange={setInputValue}
          />
        </div>
        <div className={styles.container__content}>
          <div className={styles.content}>
            {businessId
              ? businessStore.managersBusinessWidgetData
                  ?.filter(matchesSearch)
                  .map((manager, index) => (
                    <ManagerMiniCard managerInfo={manager} key={index} />
                  ))
              : businessStore.managersPointWidgetData
                  ?.filter(matchesSearch)
                  .map((manager, index) => (
                    <ManagerMiniCard managerInfo={manager} key={index} />
                  ))}
          </div>
        </div>
        {[UserRoleEnum.OWNER, UserRoleEnum.ADMINISTRATOR].includes(
          userStore.role
        ) ? (
          <div className={styles.container__button}>
            <div
              className={styles.button__wrapper}
              onClick={navigateToCreateManager}
            >
              <DefaultButton buttonText="Создать менеджера" />
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    );
  }
);
